__turbopack_context__.v({
  "Avatar": "Posts-module-scss-module__RlrONW__Avatar",
  "Content": "Posts-module-scss-module__RlrONW__Content",
  "Fallback": "Posts-module-scss-module__RlrONW__Fallback",
  "Image": "Posts-module-scss-module__RlrONW__Image",
  "Paragraph": "Posts-module-scss-module__RlrONW__Paragraph",
  "ScrollArea": "Posts-module-scss-module__RlrONW__ScrollArea",
  "Scrollbar": "Posts-module-scss-module__RlrONW__Scrollbar",
  "Thumb": "Posts-module-scss-module__RlrONW__Thumb",
  "Viewport": "Posts-module-scss-module__RlrONW__Viewport",
  "desc": "Posts-module-scss-module__RlrONW__desc",
  "footer": "Posts-module-scss-module__RlrONW__footer",
  "inline": "Posts-module-scss-module__RlrONW__inline",
  "link": "Posts-module-scss-module__RlrONW__link",
  "listItem": "Posts-module-scss-module__RlrONW__listItem",
  "mob": "Posts-module-scss-module__RlrONW__mob",
  "name": "Posts-module-scss-module__RlrONW__name",
  "position": "Posts-module-scss-module__RlrONW__position",
  "root": "Posts-module-scss-module__RlrONW__root",
  "sub": "Posts-module-scss-module__RlrONW__sub",
  "subItem": "Posts-module-scss-module__RlrONW__subItem",
  "time": "Posts-module-scss-module__RlrONW__time",
  "title": "Posts-module-scss-module__RlrONW__title",
});
